import './user-pages.sass';
import axios from 'axios';
import { useEffect, useState } from 'react';
import useAlert from '../hooks/useAlert';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Wallet = () => {
	const { t, i18n } = useTranslation();
	const { sendAlert } = useAlert();
	const token = localStorage.getItem('token');
	const walletAddress = localStorage.getItem('walletAddress');
	const [balance, setBalance] = useState('');

	useEffect(() => {
		if (token && walletAddress) {
			axios.get(`/token/getBalance/${walletAddress}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				}
			}).then((response) => {
				const message = response.data.message;
				const data = response.data.data;

				if (message === 'success') {
					setBalance(data.walletBalance);
				}
			}).catch((error) => {
				const message = error.response.data.message;

				switch (message) {
					case 'No token is provided':
						sendAlert(message, t('wallet.msg_no_auth'));
						break;

					default:
						sendAlert('Oops! an unexpected error occurred', message);
						break;
				}
			});
		}
	}, [token, walletAddress, sendAlert]);

	return (
		<div id='Wallet' className='user-pages'>
			<div className='page-title'>{t('navbar.menu_wallet')}</div>
			{/* <div className='page-content'>
				這是您的加密錢包, 它可以幫助您交易、儲存並<Link style={{textDecoration: 'underline'}} to='/user/collections'>瀏覽</Link>您在本平台<Link style={{textDecoration: 'underline'}} to='/user/exchange'>兌換</Link>的加密點數和 NFT。
			</div> */}
			<div className='page-content'>
				<div className='display-row'>
					<div className='heading'>{t('wallet.title_address')}</div>
					<div className='text'>{walletAddress}</div>
				</div>

				<div className='display-row'>
					<div className='heading'>{t('wallet.title_balance')}</div>
					<div className='text bold large'>{balance}</div>
				</div>
			</div>

			<div className='monetization-block'>Google ad</div>
		</div>
	)
}

export default Wallet;